import React, { FC } from "react";
import { Box, CircularProgress, CircularProgressProps } from "@mui/material";

interface LoaderProps {
  size?: number;
  // false for a bare inline spinner (e.g. replacing a button's label/icon
  // while it submits) - true wraps it centered in its own row, for a
  // section/page that's just "loading" on its own.
  center?: boolean;
  color?: CircularProgressProps["color"];
}

export const Loader: FC<LoaderProps> = ({ size = 32, center = true, color = "primary" }) => {
  const spinner = <CircularProgress size={size} color={color} />;

  if (!center) {
    return spinner;
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
      {spinner}
    </Box>
  );
};
